import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const Tip = (props) => {
  const { cartOrOrder } = props;
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);

  const { currency } = settings;
  const { tipTotal } = cartOrOrder;

  if (!tipTotal) {
    return null;
  }

  return (
    <>
      <div className="c7-order-summary__item">
        <div className="c7-order-summary__title">
          {t('checkout.general.tip')}
        </div>
        <div className="c7-order-summary__value">
          {currencyFormat(tipTotal, currency)}
        </div>
      </div>
    </>
  );
};

export default Tip;
